module.exports = __webpack_public_path__ + "img/wight.c9b2b758.png";